export default "__VITE_ASSET__CwR0cr1B__"